import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const BusinessDescribe = (props) => {
  const handleSubmit = (values) => {
    props.next(values, true);
  };

  const stepThreeValidationSchema = Yup.object({
    description: Yup.string().required("Description is a required field"),
  });

  return (
    <div className="businessprofile-cover">
      <h2>Please describe your council</h2>
      <Formik
        initialValues={props.data}
        onSubmit={handleSubmit}
        validationSchema={stepThreeValidationSchema}
      >
        {() => (
          <Form className="business-profile-form business-descirbe">
            <div className="form-group">
              <Field
                name="description"
                as="textarea"
                placeholder="Description"
                className="form-control"
              />
              <ErrorMessage
                name="description"
                component="div"
                className="error-message"
              />
            </div>
            <div className="form-submit">
              {" "}
              <button onClick={props.back} type="submit" className="back-btn">
                Back
              </button>
              <button type="submit" className="submit-btn">
                Done
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {/* <form className="business-profile-form business-descirbe">
                <div className="form-group">                    
                    <textarea placeholder="Description" className="form-control" />
                </div>                
                <div className="form-submit">                                        
                    <button className="submit-btn">Done</button>
                </div>
            </form> */}
    </div>
  );
};

export default BusinessDescribe;
